import { Spacer, SpacerSize } from '@components/spacer/models';
import { Block } from '@shared/models';

export const spacerMock = (size: SpacerSize = 'medium'): Block<Spacer> => ({
  type: 'spacer',
  data: {
    size,
  },
});
